module.exports = __webpack_public_path__ + "static/img/fw_qy.b2f1bddb.png";